import { z } from "zod";

export const startFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    flow: z.string(),
});

export type StartFormData = z.infer<typeof startFormSchema>;
